import OspreyApiHelper from './helper'

export default class OspreyCommunication {
  static get(path) {
    return OspreyApiHelper.genericGet(path)
  }
}



// WEBPACK FOOTER //
// src/services/osprey-api/api-communication.js